import React, { FunctionComponent, memo, ReactNode } from 'react'
import styles from './ObjectPanel.module.sass'
import clsx from 'clsx'
import { WorkObject } from '../../../../responses/objects'
import TagList from '../../tags/TagList/TagList'

interface Props {
    className?: string,
    object: WorkObject,
    inverted?: boolean
    children?: ReactNode,
}

const ObjectPanel: FunctionComponent<Props> = props => <div
    className={clsx(props.className, styles.element)}
>
    <div className={styles.name}>
        <span>{props.object.name}</span>{props.children}
    </div>
    <div className={styles.description}>{props.object.description}</div>
    <TagList inverted={props.inverted} tags={props.object.tags}/>
</div>

export default memo(ObjectPanel)